import { Document, Page, Image, Text, View, StyleSheet } from "@react-pdf/renderer";

const CTA = "Scan for our allergen & ingredients menu";

const styles = StyleSheet.create({
  page: { padding: "1cm", backgroundColor: "#FFF" },

  // --- Full A4 Poster (Page 1) ---
  poster: {
    flex: 1,
    border: "1pt solid #000",
    padding: "1cm",
    alignItems: "center",
    justifyContent: "center",
  },
  posterQR: { width: "8cm", height: "8cm", marginBottom: "0.75cm" },
  posterTitle: { fontSize: 28, fontWeight: "bold", marginBottom: "0.3cm", textAlign: "center" },
  posterLocation: { fontSize: 16, marginBottom: "0.75cm", textAlign: "center" },
  posterCTA: { fontSize: 16, marginBottom: "0.5cm", textAlign: "center" },
  posterURL: { fontSize: 10, textAlign: "center", color: "#666" },

  // --- Two Half-Page Cards (Page 2) ---
  // Two cards of 13cm each + 1.7cm spacer = 27.7cm (full A4 minus 2cm padding)
  halfCard: {
    height: "13cm",
    border: "1pt solid #000",
    flexDirection: "row",
    padding: "0.75cm",
    alignItems: "center",
  },
  halfSpacer: { height: "1.7cm" },
  halfText: { flex: 1, justifyContent: "center" },
  halfQR: { width: "5cm", height: "5cm" },
  halfTitle: { fontSize: 22, fontWeight: "bold", marginBottom: "0.3cm" },
  halfLocation: { fontSize: 14, marginBottom: "0.5cm" },
  halfCTA: { fontSize: 13, marginBottom: "0.5cm" },
  halfURL: { fontSize: 9, color: "#666" },

  // --- Four Compact Cards (Page 3) ---
  // 2×2 grid: each card 9cm × 6cm with 0.25cm margin = 9.5cm × 6.5cm per slot
  // Two columns: 2 × 9.5cm = 19cm (exact available width)
  cardGrid: { flexDirection: "row", flexWrap: "wrap" },
  compactCard: {
    width: "9cm",
    height: "6cm",
    border: "1pt solid #000",
    flexDirection: "row",
    padding: "0.35cm",
    alignItems: "center",
    margin: "0.25cm",
  },
  compactText: { flex: 1, justifyContent: "center" },
  compactQR: { width: "3cm", height: "3cm" },
  compactTitle: { fontSize: 11, fontWeight: "bold", marginBottom: "0.1cm" },
  compactLocation: { fontSize: 9, marginBottom: "0.15cm" },
  compactCTA: { fontSize: 8, marginBottom: "0.15cm" },
  compactURL: { fontSize: 7, color: "#666" },
});

const QRImage = ({ src, style }) =>
  src ? <Image src={src} style={style} /> : <Text>No QR Code</Text>;

const FullPoster = ({ details }) => (
  <View style={styles.poster}>
    <QRImage src={details.qrCode} style={styles.posterQR} />
    <Text style={styles.posterTitle}>{details.businessName}</Text>
    <Text style={styles.posterLocation}>{details.name}</Text>
    <Text style={styles.posterCTA}>{CTA}</Text>
    <Text style={styles.posterURL}>{details.businessURL}</Text>
  </View>
);

const HalfCard = ({ details }) => (
  <View style={styles.halfCard}>
    <View style={styles.halfText}>
      <Text style={styles.halfTitle}>{details.businessName}</Text>
      <Text style={styles.halfLocation}>{details.name}</Text>
      <Text style={styles.halfCTA}>{CTA}</Text>
      <Text style={styles.halfURL}>{details.businessURL}</Text>
    </View>
    <QRImage src={details.qrCode} style={styles.halfQR} />
  </View>
);

const CompactCard = ({ details }) => (
  <View style={styles.compactCard}>
    <View style={styles.compactText}>
      <Text style={styles.compactTitle}>{details.businessName}</Text>
      <Text style={styles.compactLocation}>{details.name}</Text>
      <Text style={styles.compactCTA}>{CTA}</Text>
      <Text style={styles.compactURL}>{details.businessURL}</Text>
    </View>
    <QRImage src={details.qrCode} style={styles.compactQR} />
  </View>
);

const LocationMenuPDF = ({ details }) => (
  <Document>
    {/* Page 1: Full A4 — mount on a board or wall */}
    <Page size="A4" style={styles.page}>
      <FullPoster details={details} />
    </Page>

    {/* Page 2: Two A5 cards — table inserts or framed displays */}
    <Page size="A4" style={styles.page}>
      <HalfCard details={details} />
      <View style={styles.halfSpacer} />
      <HalfCard details={details} />
    </Page>

    {/* Page 3: Four compact cards — cut out and hand to customers */}
    <Page size="A4" style={styles.page}>
      <View style={styles.cardGrid}>
        <CompactCard details={details} />
        <CompactCard details={details} />
        <CompactCard details={details} />
        <CompactCard details={details} />
      </View>
    </Page>
  </Document>
);

export default LocationMenuPDF;
